<template>
    <div class="shenbao-report">
        <el-radio-group v-model="active" style="margin-bottom: 30px;">
            <el-radio-button label="all" v-if="isCreated">成绩列表</el-radio-button>
            <el-radio-button label="user" v-show="isCreated">个人成绩</el-radio-button>
        </el-radio-group>
        <div v-if="active=='user'">
            <el-card shadow="never" :body-style="{ padding :'20px 0'}" style="border:none">
                <ul class="user-score">
                    <li>
                        <div class="total_score">
                            <p>总分</p>
                            <p>{{userData.userScore}}</p>
                            <p>
                                <el-rate v-model="scoreVal" disabled></el-rate>
                            </p>
                        </div>
                    </li>
                    <li>
                        <div>
                            <p>报告分</p>
                            <div>
                                <el-progress color="#3CD2AF" stroke-linecap="square" type="circle" :percentage="percentFun(userData.score,userData.totalScore)" :stroke-width="12" :format="format(userData.score)"></el-progress>
                            </div>
                        </div>
                        <div>
                            <p>实验分</p>
                            <div>
                                <el-progress color="#2891D2" stroke-linecap="square" type="circle" :percentage="percentFun(userData.expScore,100)" :stroke-width="12" :format="format(userData.expScore)"></el-progress>
                            </div>
                        </div>
                    </li>
                    <li>
                        <el-row :gutter="24">
                            <el-col :span="12">
                                <div>
                                    <p>实验开始时间</p>
                                    <p style="color:#ff506e">{{dataTime(userData.startDate)}}</p>
                                </div>
                            </el-col>
                            <el-col :span="12">
                                <div>
                                    <p>实验结束时间</p>
                                    <p style="color:#d755d7">{{dataTime(userData.endDate)}}</p>
                                </div>
                            </el-col>
                            <el-col :span="12">
                                <div>
                                    <p>实验时长</p>
                                    <p style="color:#a55aff">{{dataTime(userData.timeUsed)}}</p>
                                </div>
                            </el-col>
                            <el-col :span="12">
                                <div>
                                    <p>实验状态</p>
                                    <p style="color:#50a0f5;font-size:36px">
                                        {{userData.status ==1?'已完成':userData.status ==3?'未批阅':'未完成'}}
                                    </p>
                                </div>
                            </el-col>
                            <el-col :span="24" class="last_col">
                                <div>
                                    <p>知识点</p>
                                    <el-carousel indicator-position="none" :autoplay="false" height="150px">
                                        <el-carousel-item v-for="k in Math.ceil(knowData.length / 4)" :key="k">
                                            <div class="last_col_div" v-for="(i,index) in knowData.slice((k - 1) * 4, k * 4)" :key="index">
                                                <i>{{i.pointName}}</i>
                                                <span>
                                                    <el-rate v-model="i.level" disabled></el-rate>
                                                </span>
                                            </div>
                                        </el-carousel-item>
                                    </el-carousel>
                                </div>
                            </el-col>
                        </el-row>
                    </li>
                </ul>
            </el-card>
        </div>
        <div v-if="active=='all'">
            <el-table :data="data">
                <el-table-column label="头像" >
                    <template slot-scope="{ row }">
                        <el-avatar v-if="row.avatar" :size="50" :src="row.avatar | filterUrl"></el-avatar>
                        <el-avatar v-else :size="50" :src="require('@/assets/imgs/analysis/avatar.png')"></el-avatar>
                    </template>
                </el-table-column>
                <el-table-column prop="nickname" label="昵称" ></el-table-column>
                <el-table-column label="实验得分" >
                    <template slot-scope="{ row }">
                        {{row.expScore?row.expScore:'-'}}
                    </template>
                </el-table-column>
                <el-table-column label="报告得分" >
                    <template slot-scope="{ row }">
                        {{row.score?row.score:'-'}}
                    </template>
                </el-table-column>
                <el-table-column label="总得分比" >
                    <template slot-scope="{ row }">
                        {{`${row.userScore?row.userScore:'-'} / ${row.totalScore?row.totalScore:'-'}`}}
                    </template>
                </el-table-column>
            </el-table>

            <el-pagination background prev-text="上一页" next-text="下一页" layout="total, prev, pager, next, jumper" :total="page.total"
                :current-page="page.page"
                :page-size="page.limit"
                :pager-count="page.pagerCount"
                @current-change="handPageChange"
                style="margin-top:15px"
            ></el-pagination>
        </div>
    </div>
</template>
<script>
import { getRecordByUid , getRecordByShenbaoExpId } from '@/api/shenbao/shenbao-exp-user'
import { getKnowByApi } from '@/api/shenbao/shenbao-exp-knowledge'
import { getMyReport } from '@/api/lab/experiment'

export default {
    data(){
        return {
            active:'user',
            page:{
                page:1,
                limit:5,
                total:0
            },
            knowData:[],
            data:[],
            userData:{},
            scoreVal:0,
            value1: 5,
            value2: 5,
            value3: 4.1,
            value4: 3.6,
        }
    },
    props:{
        expRecordUid:{
            type:String,
            default:''
        },
        expUid:{
            type:String,
            default:''
        },
        isCreated:{
            type:Boolean,
            default: false
        },
        shenbaoExpId:{
            type:Number,
            default:null
        }
    },
    
    methods:{
        dataTime(time){
            let type = typeof time
            if(type =='string') {
                let date = new Date(time)
                let h = date.getHours() //小时
                let m = date.getMinutes() //分钟
                let s = date.getSeconds() //秒数
                let MyTime = this.getZero(h) + ':' + this.getZero(m) + ':' + this.getZero(s)
                return MyTime
            }else if(type == 'number'){
                let h = Math.floor((time)%(24*3600)/3600)
                let m = Math.floor((time % 3600) / 60);
                let s = Math.round(time % 60);
                let MyTime = this.getZero(h) + ':' + this.getZero(m) + ':' + this.getZero(s)
                return MyTime
            }else{
                return '-'
            }
        },
        getMyReport(uid){
            getMyReport(uid).then(res=>{
                if(res) {
                    this.getRecordByUid(res)
                }
            }).catch(()=>{
              // do something
            })
        },
        async getKnowByApi(shenbaoExpId,shenbaoUserId){
            await getKnowByApi(shenbaoExpId,shenbaoUserId).then(res=>{
                this.knowData = res
            })
        },
        percentFun(a,b){   //算进度条进度
            if(a && b){
                let s = Number((a/b*100).toFixed(0))
                return s
            }else{
                return 0
            }
            
        },
        startFun(a,b){  //a得分,b总分 算星级,需传得分和总分
            if(a && b){
                let s = Number(((a/b)*5).toFixed(1))
                return s
            }else{
                return 0
            }
        },
        getZero(num) {   // 单数前面加0
            if (parseInt(num) < 10) {
                num = '0' + num;
            }
            return num;
        },
        format(k) {
            return () => {
                return Math.round(k)
            }
        },
        async getRecordByUid(uid){
            await getRecordByUid(uid).then(res=>{
                this.userData = res
                this.getKnowByApi(res.shenbaoExpId,res.shenbaoUserId)
                this.scoreVal = this.startFun(this.userData.userScore,(this.userData.totalScore+100))
            })
        },
        handPageChange(page){
            this.$set(this.page,'page',page)
            this.getRecordByShenbaoExpId(this.shenbaoExpId)
        },
        getRecordByShenbaoExpId(){
            let params = {
                shenbaoExpId:this.shenbaoExpId
            }
            const { page,limit } = this.page
            getRecordByShenbaoExpId(this.shenbaoExpId,page,limit,params).then(res=>{
                const { totalCount,list } = res
                this.data = list
                this.$set(this.page,'total',totalCount)
            })
        }
    },
    watch:{
        isCreated:{
            deep:true,
            immediate: true,
            handler: function (newVal) {
                if(newVal) this.active = 'all'
                else this.active = 'user'
            }
        },
        active:{
            immediate: true,
            handler: function (newVal) {
                if(newVal=='user'){
                    if(this.expUid) this.getMyReport(this.expUid)
                    else  this.getRecordByUid(this.expRecordUid)
                }else{
                    this.getRecordByShenbaoExpId()
                }
            }
        }
    }
}
</script>
<style lang="less">
.shenbao-report{
    .user-score{
        height: 548px;
        >li{
            float: left;
            height: 100%;
        }
        >li:nth-of-type(1){
            margin-right: 24px;
            margin-left: 12px;
            width: 216px;
            background: url('~@/assets/imgs/analysis/score-bg.png');
            background-size: 100% 100%;
            box-shadow: 0px 5px 10px #e7e4dc;
            border-radius: 0 0 12px 12px;
            position: relative;
            .total_score{
                p:nth-of-type(1){
                    position: absolute;
                    top: 140px;
                    left: 80px;
                    font-size: 30px;
                    color: #999;
                }
                p:nth-of-type(2){
                    position: absolute;
                    top: 200px;
                    left: 6px;
                    width: 200px;
                    text-align: center;
                    font-size: 96px;
                    color: #F5A01E;
                }
                p:nth-of-type(3){
                    position: absolute;
                    top: 300px;
                    left: 36px;
                    font-size: 96px;
                    color: #F5A01E;
                    .el-rate__icon{
                        font-size: 24px;
                    }
                }
            }
        }   
        li:nth-of-type(2){
            margin-right: 24px;
            width: 320px;
            >div{
                width: 100%;
                height: 262px;
                box-shadow: 0px 5px 10px #e7e4dc;
                border-radius: 15px;
                padding: 24px;
                p{
                    font-size: 20px;
                    color: #999;
                }
                >div{
                    text-align: center;
                    margin-top: 30px;
                }
            }
            >div:nth-of-type(1){
                margin-bottom: 24px;
            }
        }
        li:nth-of-type(3){
            width: 480px;
            .el-row{
                height: 100%;
                >.el-col{
                    height: 140px;
                    margin-bottom: 24px;
                    >div{
                        padding: 24px;
                        width: 100%;
                        height: 100%;
                        box-shadow: 0px 5px 10px #e7e4dc;
                        border-radius: 15px;
                        p:nth-of-type(1){
                            font-size: 20px;
                            color: #999;
                        }
                        p:nth-of-type(2){
                            text-align: center;
                            font-size: 44px;
                            font-weight: 600;
                            margin-top: 12px;
                        }
                    }
                }
                .last_col{
                    >div{
                        height: 220px;
                        box-shadow: 0px 5px 10px #e7e4dc;
                        border-radius: 15px;
                        .last_col_div{
                            margin-top: 12px;
                            overflow: hidden;
                            text-align: right;
                            i{
                                font-style: normal;
                                float: left;
                            }
                            
                        }
                    }
                }
            }
        }
    }
}
</style>
